import { html } from 'lit';

export const playIcon = html`
<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="0"
    strokeLinecap="round"
    strokeLinejoin="round"
>
    <polygon points="5 3 19 12 5 21 5 3" />
</svg>
`;